import React from 'react';
import {Button, Dropdown, Grid, Input} from 'semantic-ui-react';
import {pageSizeFloatingInventory} from '../../../../common/constants/lists';

const TablePaginator = ({
  page,
  canPreviousPage,
  pageIndex,
  pageOptions,
  pageSize,
  canNextPage,
  nextPage,
  gotoPage,
  previousPage,
  setPageSize,
  lineOpen = false,
}) => {
  if (page.length) {
    return (
      <Grid className="pagination" verticalAlign='middle'>
        <Grid.Row >
          <Grid.Column width={4} textAlign="left">
            <Button
              className="navigation-button"
              onClick={() => previousPage()}
              disabled={!canPreviousPage || lineOpen}
              content="Anterior"
            />
          </Grid.Column>
          <Grid.Column width={4} textAlign="right">
            <span>páginas </span>
            <span>
              <Input
                disabled={lineOpen}
                className="pages-input"
                type="number"
                value={pageIndex + 1}
                min="1"
                max={pageOptions.length}
                onChange={(e, {value}) => {
                  const page = value ? Number(value) - 1 : 0;
                  if (page < 1 || page > pageOptions.length) {
                    e.target.value = 1;
                  }
                  gotoPage(page);
                }}
              />
            </span>{' '}
            <span>de {pageOptions.length}</span>
          </Grid.Column>
          <Grid.Column width={4} textAlign="left">
            <Dropdown
              disabled={lineOpen}
              className="page-sizes-selection"
              selection
              upward
              compact
              value={pageSize}
              options={pageSizeFloatingInventory}
              onChange={(e, {value}) => {
                setPageSize(Number(value));
              }}
            />
            <span> filas</span>
          </Grid.Column>
          <Grid.Column width={4} textAlign="right">
            <Button
              className="navigation-button"
              onClick={() => nextPage()}
              disabled={!canNextPage || lineOpen}
              content="Siguiente"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  return null;
};

export default TablePaginator;
